export const UC_QUERY_KEYS = {
  telegramCampaigns: "uc_telegram_campaigns",
  telegramCampaignDetails: "uc_telegram_campaign_details",
  telegramRecipients: "uc_telegram_recipients",
  telegramCommunities: "uc_telegram_communities",
  telegramCommunitiesPaginated: "uc_telegram_communities_paginated",
  telegramContacts: "uc_telegram_contacts",
  telegramAudienceSummary: "uc_telegram_audience_summary",
  telegramConnection: "uc_telegram_connection",
  telegramCredits: "uc_telegram_credits",
  broadcastTemplates: "uc_broadcast_templates",
  telegramDefaultTemplates: "uc_telegram_default_templates",
  telegramCustomTemplates: "uc_telegram_custom_templates",
  pushDefaultTemplates: "uc_push_default_templates",
  pushCustomTemplates: "uc_push_custom_templates",
  communityDefaultTemplates: "uc_community_default_templates",
  communityCustomTemplates: "uc_community_custom_templates",
  communitySpaces: "uc_community_spaces",
  communitySpacesPaginated: "uc_community_spaces_paginated",
  communityCampaigns: "uc_community_campaigns",
  pushCampaigns: "uc_push_campaigns",
  pushAvailability: "uc_push_availability",
  pushCredits: "uc_push_credits",
  tradeCallsPicker: "uc_trade_calls_picker",
  rationalePdfDesign: "uc_rationale_pdf_design",
  sebiReportsVisibility: "uc_sebi_reports_visibility",
  templateDetails: "uc_template_details",
  whatsappCustomTemplates: "uc_whatsapp_custom_templates",
  audienceGroups: "uc_audience_groups",
  whatsappBroadcastStats: "uc_whatsapp_broadcast_stats",
  emailBroadcastStats: "uc_email_broadcast_stats",
  broadcastUsageMetrics: "uc_broadcast_usage_metrics",
};
